import _ from 'lodash';
import { createSelector } from 'reselect';
import { checkIsBusinessManager } from 'bm-integration/utils/business-manager-api';
import { isNumberOfRowsForClassicEnabled } from './app-settings';

function getExperiments(state) {
  return state.experiments;
}

export const experimentsFetched = createSelector(getExperiments, _.negate(_.isNil));

/**
 * @param {object} state
 * @param {string} experimentName
 * @returns {boolean} Is experiment enabled
 */
export const isEnabled = createSelector(
  [
    getExperiments,
    (state, experimentName) => experimentName,
  ],
  (experiments, experimentName) => _.get(experiments, experimentName) === 'true',
);

export function isPremiumIntentEnabled(state) {
  return !isEnabled(state, 'specs.vod.disablePremiumIntent');
}

export function isCacheFacebookCoversEnabled(state) {
  return isEnabled(state, 'specs.vod.cacheFacebookCovers');
}

export function isPullInfoEnabled(state) {
  return isEnabled(state, 'specs.vod.pullInfo');
}

export function isLiveEnabled(state) {
  return isEnabled(state, 'specs.vod.live');
}

export function isScheduleLiveEnabled(state) {
  return isEnabled(state, 'specs.vod.scheduleLive');
}

export function isBusinessManagerEnabled(state) {
  return isEnabled(state, 'specs.wos.DisplayVideo') && checkIsBusinessManager();
}

export function isInBusinessManager(state) { // used for app-settings
  if (_.isNull(state.businessManager.isInBusinessManager)) {
    return isEnabled(state, 'specs.wos.DisplayVideo') && isEnabled(state, 'specs.wos.businessManagerPhase4');
  }

  return state.businessManager.isInBusinessManager;
}

export function isForceCashierPayments(state) {
  return isEnabled(state, 'specs.vod.forceCashierPayment');
}

export function isFBPlayerHackEnabled(state) {
  return isEnabled(state, 'specs.vod.hackFBPlayerDimensions');
}

export function isNumberOfRowsSpecEnabled(state) {
  return isEnabled(state, 'specs.vod.numbersOfRowsClassic');
}

export const isNumberOfRowsEnabled = createSelector(
  isNumberOfRowsForClassicEnabled,
  isNumberOfRowsSpecEnabled,
  (isAppSettingsFTenabled, isSpecEnabled) => isAppSettingsFTenabled && isSpecEnabled
);

export function isBusinessManagerSettingsFetched(state) {
  return !_.isNil(state.businessManagerSettings);
}

export function isUoUBusinessManagerEnabled(state) {
  return _.get(state, 'businessManagerSettings.inBizManager');
}

export function isSingleVideoEnabled(state) {
  return isEnabled(state, 'specs.vod.singleVideo');
}

export function isOverQuotaStateEnabled(state) {
  return isEnabled(state, 'specs.vod.overQuotaState');
}

export function isFrontendVideoPublishDisabled(state) {
  return isEnabled(state, 'specs.vod.disableFrontendVideoPublish');
}

export function areNotificationsDisabled(state) {
  return isEnabled(state, 'specs.vod.disableNotifications');
}

export function isThankYouPageEnabled(state) {
  return isEnabled(state, 'specs.vod.thankYouPage');
}

/**
 * @param {object} state
 * @returns {string[]} Enabled experiment names list
 */
export const getEnabledExperimentsList = createSelector(
  [
    getExperiments,
  ],
  experiments =>
    _(experiments)
      .pickBy(val => val === 'true')
      .keys()
      .value(),
);



// WEBPACK FOOTER //
// ./src/shared/selectors/experiments.js